module.exports = {"350302001":"龙桥街道","350302002":"凤凰山街道","350302003":"霞林街道","350302100":"常太镇","350302101":"华亭镇","350302102":"灵川镇","350302103":"东海镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350302.json
// module id = 1289
// module chunks = 0